'use client';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles(function(theme, param) {
    var shadow = param.shadow;
    return {
        dropdown: _extends({
            boxSizing: "border-box",
            position: "absolute"
        }, shadow && {
            boxShadow: theme.shadows[shadow] || shadow
        }, {
            backgroundColor: theme.palette.background.highlight,
            padding: "0.5rem 0.75rem",
            borderRadius: "0.5rem",
            "&:focus": {
                outline: 0
            }
        }),
        arrow: {
            backgroundColor: "inherit",
            zIndex: 1
        }
    };
});

export { useStyles as default };
